document.documentElement.classList.remove('no-js');

document.addEventListener('change', function(event) {
  if (event.target.matches('[data-variant-select]')) {
    const option = event.target.options[event.target.selectedIndex];
    const form = event.target.closest('form');
    const idInput = form ? form.querySelector('[name="id"]') : document.querySelector('[name="id"]');
    const price = document.querySelector('[data-product-price]');
    if (idInput) idInput.value = event.target.value;
    if (price && option.dataset.price) price.textContent = option.dataset.price;
  }
});

(function(){
  const gallery = document.querySelector('[data-product-gallery]');
  if (!gallery) return;

  const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
  const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
  const prev = gallery.querySelector('[data-gallery-prev]');
  const next = gallery.querySelector('[data-gallery-next]');
  const current = gallery.querySelector('[data-gallery-current]');
  if (!slides.length) return;

  let index = 0;
  let touchStartX = null;

  function show(nextIndex) {
    index = (nextIndex + slides.length) % slides.length;
    slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
    thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === index));
    if (current) current.textContent = String(index + 1);
    if (thumbs[index]) thumbs[index].scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
  }

  function showMedia(mediaId) {
    if (!mediaId) return;
    const target = slides.findIndex(slide => String(slide.dataset.mediaId) === String(mediaId));
    if (target >= 0) show(target);
  }

  if (prev) prev.addEventListener('click', () => show(index - 1));
  if (next) next.addEventListener('click', () => show(index + 1));
  thumbs.forEach(thumb => thumb.addEventListener('click', () => show(Number(thumb.dataset.index))));

  const stage = gallery.querySelector('.product-gallery__stage');
  if (stage) {
    stage.addEventListener('touchstart', event => {
      touchStartX = event.changedTouches[0].clientX;
    }, { passive: true });
    stage.addEventListener('touchend', event => {
      if (touchStartX === null) return;
      const delta = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(delta) > 45) show(index + (delta < 0 ? 1 : -1));
      touchStartX = null;
    }, { passive: true });
  }

  document.querySelectorAll('[data-colour-add]').forEach(button => {
    button.addEventListener('mouseenter', () => showMedia(button.dataset.mediaId));
    button.addEventListener('focus', () => showMedia(button.dataset.mediaId));
    button.addEventListener('click', () => {
      const price = document.querySelector('[data-product-price]');
      if (price && button.dataset.price) price.textContent = button.dataset.price;
      showMedia(button.dataset.mediaId);
    });
  });
})();

// Little Bees V7 delivery estimate. Recalculates in the shopper's browser so dates stay current.
(function(){
  function addDays(start, count, businessOnly){
    var d = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    var added = 0;
    while(added < count){
      d.setDate(d.getDate()+1);
      if(!businessOnly || (d.getDay() !== 0 && d.getDay() !== 6)) added++;
    }
    return d;
  }
  function formatDate(d){
    return new Intl.DateTimeFormat(undefined,{day:'numeric',month:'long'}).format(d);
  }
  document.querySelectorAll('[data-delivery-estimate]').forEach(function(el){
    var min = parseInt(el.dataset.minDays || '7',10);
    var max = parseInt(el.dataset.maxDays || '12',10);
    if(max < min) max = min;
    var businessOnly = el.dataset.businessDays === 'true';
    var today = new Date();
    var from = el.querySelector('[data-delivery-from]');
    var to = el.querySelector('[data-delivery-to]');
    if(from) from.textContent = formatDate(addDays(today,min,businessOnly));
    if(to) to.textContent = formatDate(addDays(today,max,businessOnly));
  });
})();
